// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"339":"384e2711","532":"styles","678":"component---src-pages-index-js"}[chunkId] + "-" + {"339":"6d162298b933f9d10f36","532":"c1b30e72dd1c97ef80cb","678":"2a89509ca40e7cf515b3"}[chunkId] + ".js";
};